import { http } from "./api-config";

const apiClient = http(process.env.VUE_APP_SEARCH_SEVICE)

export default {
    async getSearchResults(query) {
        const queryString = new URLSearchParams(query).toString()
        const res = await apiClient.get(`search?${queryString}`)
        return res.data
    },
}